import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

interface IStandardButtonProps {
    text: string;
    link?: string;
}

export const buttonStyles: IButtonStyles = {
    root: {
        margin: '0 4rem 1rem 4rem',
        fontWeight: '400',
        whiteSpace: 'nowrap',
    },
};

const StandardButton: React.FC<IStandardButtonProps> = ({ text, link }) => {
    return (
        <DefaultButton
            text={text}
            disabled={!link}
            href={link}
            target="_blank"
            rel="noreferrer noopener"
            styles={buttonStyles}
        />
    );
};

export default StandardButton;
